import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import styled, { css } from 'styled-components';
import Grid from '../Grid';
import Text from '../Text';
import Config from '../../config';
import { withTheme } from '../../core/ThemeProvider';
import { withStyledAttrs } from '../../helpers/styled';
export var Content = styled.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-k2g059-0"
})(["width:auto;"]);
export var AnimationWrapper = styled.div.withConfig({
  displayName: "styles__AnimationWrapper",
  componentId: "sc-k2g059-1"
})(["z-index:", ";position:fixed;width:100%;height:100%;pointer-events:none;"], function (p) {
  return p.zIndex;
});
export var NoPaddingGrid = styled(Grid).withConfig({
  displayName: "styles__NoPaddingGrid",
  componentId: "sc-k2g059-2"
})(["padding-top:0;padding-bottom:0;", ";"], Config.media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 0px;\n  "]))));
export var ToastComponent = withTheme(styled.div.withConfig({
  displayName: "styles__ToastComponent",
  componentId: "sc-k2g059-3"
})(function (_ref) {
  var coreTheme = _ref.coreTheme;
  return css(["pointer-events:auto;box-sizing:border-box;position:absolute;background-color:", ";bottom:16px;border-radius:", ";width:100%;height:80px;display:flex;padding:16px;", ";"], coreTheme.cl_ter_l1, coreTheme.rad_xl, Config.media.sm(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        bottom: 40px;\n        padding: 25px;\n      "]))));
}));
export var IconWrapper = styled.div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-k2g059-4"
})(["align-self:center;height:24px;margin-right:16px;", ";"], Config.media.sm(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-right: 24px;\n  "]))));
export var Title = withTheme(withStyledAttrs(Text, {
  type: 'body'
})(function (_ref2) {
  var coreTheme = _ref2.coreTheme;
  return css(["display:-webkit-box;text-overflow:ellipsis;flex:1;text-align:left;overflow:hidden;align-self:center;color:", ";-webkit-box-orient:vertical;-webkit-line-clamp:2;", ";"], coreTheme.cl_ter_l6, Config.media.sm(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        -webkit-line-clamp: 1;\n      "]))));
}));
export var Action = withTheme(withStyledAttrs(Text, {
  type: 'link'
})(function (_ref3) {
  var coreTheme = _ref3.coreTheme;
  return css(["align-items:center;color:", ";cursor:pointer;display:inline-flex;margin-left:16px;", ";"], coreTheme.cl_sec_l2, Config.media.sm(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        margin-left: 24px;\n      "]))));
}));